<ng-container *ngIf="showCollapse; else template">
  <div [ngClass]="{ 'p-d-flex': collapsed }" (click)="onContainerClick()">
    <div [ngClass]="{ 'collapse-text-container': collapsed }">
      <ng-container *ngTemplateOutlet="template"></ng-container>
      <a *ngIf="!collapsed" class="link">
        <div style="word-break: keep-all; white-space: nowrap">
          {{ 'Collapse' | translate }}
        </div>
      </a>
    </div>
    <a *ngIf="collapsed" class="link p-d-flex p-ai-end">
      <div style="word-break: keep-all; white-space: nowrap">
        {{ 'More' | translate }}
      </div>
    </a>
  </div>
</ng-container>
<ng-template #template>
  <div
    #content
    class="text-collapse-more"
    [ngClass]="{ 'text-collapse-disable': !collapsed }"
    [ngStyle]="{
      '-webkit-line-clamp': line,
      'word-break': collapsed ? 'break-all' : 'inherit'
    }"
  >
    <div class="style-cover">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
  </div>
</ng-template>
